import React, { useState } from 'react'
import Axios from 'axios';
import './App.css';

function App() {
  const [APIKey, setAPIKey] = useState("53D875D6-328B-4D24-9D37-D9CDA1E82E1E");
  const [UniqueID, setUniqueID] = useState(Math.floor(Math.random()*1000000000)+1);
  const [ServiceName, setServiceName] = useState("spRSTestOnly");
  const [Arguments, setArguments] = useState("{}");
  const [Response, setResponse] = useState("");

  const displayInfo = () => {
    // const url = "http://localhost:21394/iotaDataServices.svc/SQLExecute";
    // const url = "https://xs2023.ximbrasoft.ch:5003/iotaDataServices.svc/SQLExecute"
    const url = "https://dataservice.ximbrasoft.ch:5003/iotaDataServices.svc/SQLExecute"
    const data = JSON.stringify({"APIKey":APIKey, "UniqueID":UniqueID, "ServiceName":ServiceName, "Arguments":Arguments});
    console.log(data);
  
    Axios.post(url, data, {
      // Header Information
      dataType: 'json',
			crossDomain: true
    }).then((response) => {
      console.log(response.data);
      setResponse(response.data)
    }).catch(err => {
      console.log(err);
      setResponse(err);
    })
    
  }

  const resetFields = () => {
    setAPIKey("53D875D6-328B-4D24-9D37-D9CDA1E82E1E");
    setUniqueID(Math.floor(Math.random()*1000000000)+1);
    setServiceName("spRSTestOnly");
    setArguments("{}");
    setResponse("");
  }
  
  return (
    <div className="App">
      <h1>iota DataService Test (React)</h1>
      <div className="arguments">
        <label>API Key:</label> 
        <input type="text" value={APIKey} onChange={(event) => {setAPIKey(event.target.value)}}/>
        <label>UniqueID:</label> 
        <input type="text" readOnly value={UniqueID} onChange={(event) => {setUniqueID(event.target.value)}}/>
        <label>Service Name:</label> 
        <input type="text" value={ServiceName} onChange={(event) => {setServiceName(event.target.value)}}/>
        <label>Arguments (JSON):</label> 
        <input type="text" value={Arguments} style={{height:"40px"}} onChange={(event) => {setArguments(event.target.value)}}/>
        
        <button onClick={displayInfo}>Send/Receive Data</button>
        <button style={{backgroundColor:"blue"}} onClick={resetFields}>Reset Fields</button>

        <label style={{color:"blue", marginTop:"50px"}}>Result (JSON):</label> 
        <textarea value={Response} readOnly></textarea>
      </div>
    </div>
  );
}

export default App;
